document.documentElement.classList.remove('no-js');

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) entry.target.classList.add('is-visible');
  });
}, { threshold: 0.12 });

document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-scroll-buy]');
  if (!trigger) return;
  const target = document.querySelector('#ProductForm') || document.querySelector('form[action*="/cart/add"]');
  if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
});


document.querySelectorAll('[data-before-after]').forEach((wrap) => {
  const range = wrap.querySelector('[data-ba-range]');
  const after = wrap.querySelector('[data-ba-after]');
  const line = wrap.querySelector('[data-ba-line]');
  if (!range || !after || !line) return;

  const update = () => {
    const value = `${range.value}%`;
    after.style.width = value;
    line.style.left = value;
  };
  range.addEventListener('input', update);
  update();
});
